import ViewBase from "../views/view-base.view";
import WidgetContainerComponent from "../components/widget/widget-container.component";
import TasksStatusDonutChartComponent from "../components/charts/pie/tasks-status-donut-chart.component";
import TasksChartComponent from "../components/charts/xy/tasks-chart.component";
import TasksStoresPieChartComponent from "../components/charts/pie/tasks-stores-pie-chart.component";
import HomeDashboardModel from "../models/home/home-dashboard.model";

export default function SchedulesAndTasksWidget() {

  ViewBase.call(this);

  let chartData1;
  let chartData2;
  let chartData3;

  let getChartData = function () {

    HomeDashboardModel.getScheduleVisitStatusData(
      (result) => {
        chartData1 = {};
        chartData1.visitResponse = result.visitResponse;
        chartData1.scheduleTypeResponse = result.scheduleTypeResponse;
      }, (error) => {
        console.error('getScheduleVisitStatusData - error', JSON.parse(JSON.stringify(error)))
      }
      // TEST DATA from certain date
      // , "20220701"
    );

    HomeDashboardModel.getTaskTypeAndStatusData(
      (result) => {
        chartData2 = result.typeDetails;
      }, (error) => {
        console.error('getTaskTypeAndStatusData - error', JSON.parse(JSON.stringify(error)))
      }
      // TEST DATA from certain date
      // , {
      //   fromDate: "20220701",
      //   toDate: "20220701",
      // }
    );

    HomeDashboardModel.getTaskStoreStatusData(
      (result) => {
        chartData3 = result.categoryDetails;
      }, (error) => {
        console.error('getTaskStoreStatusData - error', JSON.parse(JSON.stringify(error)))
      }
      // TEST DATA from certain date
      // , {
      //   fromDate: "20220701",
      //   toDate: "20220701",
      // }
    );

  }

  return {
    oninit: (vnode) => {
      getChartData();
    },
    view: (vnode) => {
      return [
        m(WidgetContainerComponent,
          {
            title: this.getText('LT00000113', 'Schedules & Tasks'),
            links: [
              {
                text: this.getText('LT00000124', 'Schedules'),
                url: '/schedule/visit-rate'
              },
              {
                text: this.getText('LT00000110', 'Tasks'),
                url: '/to-do'
              }
            ],
          }, [
          m('.row.g-3', [
            m('.col-md-4',
              m('.card.widget-component', m('.card-body',
                chartData1 &&
                m(TasksStatusDonutChartComponent, { data: chartData1 })
              )),
            ),
            m('.col-md-4',
              m('.card.widget-component', m('.card-body',
                chartData2 &&
                m(TasksChartComponent, { data: chartData2 })
              )),
            ),
            m('.col-md-4',
              m('.card.widget-component', m('.card-body',
                chartData3 &&
                m(TasksStoresPieChartComponent, { data: chartData3 })
              )),
            ),
          ]),
        ]
        ),
      ]
    }
  }
}
